import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getOpeningBalances, saveOpeningBalances } from '../../../api/OpeningBalanceAPI';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import { getAvatar } from '../../../commonfunctions';

const OpeningBalancePage = () => {
    const navigate = useNavigate();
    const [members, setMembers] = useState([]);
    const [balances, setBalances] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        // This now fetches the users with their saved balances
        getOpeningBalances((response) => {
            if (response.users_with_balances) {
                const users = response.users_with_balances;
                setMembers(users);
                
                const initialBalances = {};
                users.forEach(user => {
                    initialBalances[user.id] = {
                        user_id: user.id,
                        ob_date: user.opening_balance?.ob_date || new Date().toISOString().slice(0, 10),
                        ob_amount: user.opening_balance?.ob_amount || 0,
                        remarks: user.opening_balance?.remarks || ''
                    };
                });
                setBalances(initialBalances);
            }
            setIsLoading(false);
        });
    }, []);

    const handleInputChange = (userId, field, value) => {
        setBalances(prev => ({
            ...prev,
            [userId]: { ...prev[userId], [field]: value }
        }));
    };

    const handleSubmit = () => {
        setIsSaving(true);
        // We now send all balances, including zeros, to handle deletions.
        const balancesToSave = Object.values(balances);
        
        saveOpeningBalances(balancesToSave, (response) => {
            setIsSaving(false);
            if (response.message) {
                Swal.fire('Success!', response.message, 'success');
            } else {
                Swal.fire('Error!', 'Could not save opening balances.', 'error');
            }
        });
    };

    if (isLoading) return <div className="text-center p-5"><div className="spinner-border"></div></div>;

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Opening Balances" />
                <div className="card">
                    <div className="card-header">
                        <h5>Set Member Wallet Opening Balances</h5>
                        <p className="text-muted">Enter the starting wallet balance for each member. Set an amount to 0 to remove a balance.</p>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Member</th>
                                        <th>Date</th>
                                        <th>Opening Amount (₹)</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {members.map(member => (
                                        <tr key={member.id}>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <img src={getAvatar(member.profile_pic_path)} alt={member.name} className="rounded-circle me-2" width="30" height="30" />
                                                    {member.name}
                                                </div>
                                            </td>
                                            <td>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={balances[member.id]?.ob_date || ''}
                                                    onChange={(e) => handleInputChange(member.id, 'ob_date', e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={balances[member.id]?.ob_amount || 0}
                                                    onChange={(e) => handleInputChange(member.id, 'ob_amount', e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="e.g., Carried over from old book"
                                                    value={balances[member.id]?.remarks || ''}
                                                    onChange={(e) => handleInputChange(member.id, 'remarks', e.target.value)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="card-footer text-end">
                        <button className="btn btn-primary" onClick={handleSubmit} disabled={isSaving}>
                            {isSaving ? 'Saving...' : 'Save All Balances'}
                        </button>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default OpeningBalancePage;

